import { updateBreadcrumbs } from '../../app/actions/UpdateBreadcrumbsAction';
import { appStore } from '../../app/AppStore';
import { BreadcrumbStateInfo } from '../../app/content/breadcrumbs/BreadcrumbStateInfo';
import { Messages } from '../../codegen/Localize';
import { IViz, VizType } from '../models/Viz';
import { Module } from '../Module';
import { BrowserTitleService } from '../services/BrowserTitleService';
import { TopBarService } from '../services/TopBarService';
import { VizService } from '../services/VizService';

export interface IAdminVizStateParams extends ng.ui.IStateParamsService {
  sheetUrlId: string;
}

export interface IAdminVizScope extends ng.IScope {
  viz: IViz;
}

export class AdminVizViewerCtrl {

  // We can't get admin view names from the Views service, so we use hardcoded loc strings
  private static ViewNameLocKeyDict: _.Dictionary<() => string> = {
    ActionsbyAllUsers: Messages.actionsByAllUsersTitle,
    ActionsbySpecificUser: Messages.actionsByASpecificUserTitle,
    ActionsbyRecentUsers: Messages.actionsByRecentlySignedInUsersTitle,
    BackgroundTaskDelays: Messages.backgroundTaskDelaysTitle,
    BackgroundTasksforExtracts: Messages.backgroundTasksExtractsTitle,
    BridgeTasksforExtracts: Messages.bridgeTasksExtractsTitle,
    BackgroundTasksforNonExtracts: Messages.backgroundTasksNonExtractsTitle,
    DesktopLicenseUsage: Messages.desktopLicenseUsageTitle,
    DesktopLicenseExpirations: Messages.desktopLicenseExpirationsTitle,
    LoginBasedLicenseUsage: Messages.ibaLicenseUsageTitle,
    ServerDiskSpace: Messages.serverDiskSpaceTitle,
    PerformanceofViews: Messages.performanceofViewsTitle,
    PerformanceofFlowRuns: Messages.performanceofFlowRunsTitle,
    StatsforLoadTimes: Messages.statsLoadTimesTitle,
    StatsforSpaceUsage: Messages.statsSpaceUsageTitle,
    TraffictoBridgeconnectedDatasources: Messages.trafficToBridgeDataSourcesTitle,
    TraffictoDataSources: Messages.trafficToDataSourcesTitle,
    TraffictoViews: Messages.trafficToViewsTitle
  };

  private sheetUrlId: string;

  public static $inject = [
    '$scope',
    '$stateParams',
    '$location',
    '$state',
    'BrowserTitleService',
    'TopBarService',
    'VizService',
    'workbookUrlId'
  ];

  constructor(
    $scope: IAdminVizScope,
    $stateParams: IAdminVizStateParams,
    $location: ng.ILocationService,
    private $state: ng.ui.IStateService,
    BrowserTitleService: BrowserTitleService,
    topBarService: TopBarService,
    vizService: VizService,
    workbookUrlId: string)
  {
    this.sheetUrlId = $stateParams.sheetUrlId;

    $scope.viz = {
      path: workbookUrlId + '/' + this.sheetUrlId,
      vizType: VizType.Admin,
      params: $location.search()
    };

    vizService.reloadOnLocationChange($scope);

    $scope.$watch('viz.path', (newPath: string) => {
      this.sheetUrlId = newPath.split('/')[1];
      vizService.updatePath($scope, {sheetUrlId: this.sheetUrlId});
      const workbookName = this.isServerAnalysis() ? Messages.serverStatus() : Messages.siteStatus();
      BrowserTitleService.setVizTitle(this.getViewName(), workbookName);
      appStore.dispatch(updateBreadcrumbs(this.buildBreadcrumbs()));
    });

    appStore.dispatch(updateBreadcrumbs(this.buildBreadcrumbs()));
  }

  private isServerAnalysis() {
    return this.$state.includes('**.server.**');
  }

  private getViewName() {
    return AdminVizViewerCtrl.ViewNameLocKeyDict[this.sheetUrlId]();
  }

  private buildBreadcrumbs(): BreadcrumbStateInfo[] {
    return [
      this.isServerAnalysis() ? this.serverStatusBreadcrumb() : this.siteStatusBreadcrumb(),
      { text: this.getViewName() }
    ];
  }

  private serverStatusBreadcrumb(): BreadcrumbStateInfo {
    return {
      id: this.$state.href('main.server.status'),
      text: Messages.serverStatus(),
      href: this.$state.href('main.server.status'),
      testId: 'server-status-link'
    };
  }

  private siteStatusBreadcrumb(): BreadcrumbStateInfo {
    return {
      id: this.$state.href('main.site.status'),
      text: Messages.siteStatus(),
      href: this.$state.href('main.site.status'),
      testId: 'site-status-link'
    };
  }

}

Module.instance().controller('AdminVizViewerCtrl', AdminVizViewerCtrl);
